import { useEffect, useMemo, useState } from "react";
import api from "../../lib/api";
import AdminLayout from "./AdminLayout";
import { Award, Search } from "lucide-react";

export default function AdminLoyalty() {
    const [rows, setRows] = useState([]);
    const [q, setQ] = useState("");

    useEffect(() => { api.get("/admin/loyalty/users").then(({ data }) => setRows(data)); }, []);

    const filtered = useMemo(() => {
        const term = q.trim().toLowerCase();
        if (!term) return rows;
        return rows.filter(r => (r.name || "").toLowerCase().includes(term) || (r.email || "").toLowerCase().includes(term) || (r.phone || "").includes(term));
    }, [rows, q]);

    return (
        <AdminLayout>
            <div className="p-4 sm:p-8">
                <div className="flex items-center gap-2">
                    <Award className="w-5 h-5 text-[#00FF66]" />
                    <h1 className="font-display text-3xl font-bold uppercase text-white">Loyalty Program</h1>
                </div>
                <p className="text-slate-400 text-sm mt-1">100 pts per completed booking. Redeem rule: min 500 pts → up to 20% of current balance. Per-user totals shown below.</p>

                <div className="mt-6 relative max-w-md">
                    <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
                    <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name / email / phone"
                        data-testid="loyalty-search"
                        className="w-full h-10 pl-9 pr-3 bg-slate-900 border border-slate-700 rounded text-white text-sm focus:outline-none focus:ring-2 focus:ring-[#00FF66]" />
                </div>

                <div className="mt-5 bg-slate-900 border border-slate-800 rounded-lg overflow-hidden" data-testid="loyalty-table">
                    <div className="grid grid-cols-12 px-4 py-3 bg-slate-950/60 border-b border-slate-800 text-[10px] font-bold tracking-[0.2em] uppercase text-slate-500">
                        <div className="col-span-4">Customer</div>
                        <div className="col-span-3">Phone</div>
                        <div className="col-span-2 text-right">Balance</div>
                        <div className="col-span-1 text-right">Earned</div>
                        <div className="col-span-2 text-right">Redeemed</div>
                    </div>
                    {filtered.length === 0 && <div className="text-slate-500 text-center py-8">No customers</div>}
                    {filtered.map(r => (
                        <div key={r.user_id} data-testid={`loyalty-row-${r.user_id}`}
                            className="grid grid-cols-12 px-4 py-3 border-b border-slate-800/70 text-sm hover:bg-slate-950/40">
                            <div className="col-span-4">
                                <div className="font-bold text-white">{r.name}</div>
                                <div className="text-xs text-slate-500">{r.email}</div>
                            </div>
                            <div className="col-span-3 text-slate-400">{r.phone || "—"}</div>
                            <div className="col-span-2 text-right font-bold text-[#00FF66]">{r.balance.toLocaleString("en-IN")}</div>
                            <div className="col-span-1 text-right text-slate-300">{r.lifetime_earned.toLocaleString("en-IN")}</div>
                            <div className="col-span-2 text-right text-amber-400">{r.lifetime_redeemed.toLocaleString("en-IN")}</div>
                        </div>
                    ))}
                </div>
            </div>
        </AdminLayout>
    );
}
